<template>
  <echeancier-facturation :dcf="commandeTlpe"
                        :showErrorDate="false"
                        :isEdit="false"
  />
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import echeancierFacturation from '@/components/devisCommandes/detailDevisCommande/echeancierFacturation';

const Permissions = createNamespacedHelpers('permissions');

export default {
  components: {
    echeancierFacturation,
  },
  props: {
    commandeTlpe: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
  },
};
</script>
